import { render, staticRenderFns } from "./ReligionForm.vue?vue&type=template&id=1032b23a&"
import script from "./ReligionForm.vue?vue&type=script&lang=js&"
export * from "./ReligionForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports